import { Modal, ModalProps, Form, Select, Row, Col, Spin, message, DatePicker, Switch } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { FieldData } from 'rc-field-form/es/interface';

import SurveysService from '../SurveysService';
import ApiError from '../../core/ApiError';

import styles from './downloadreportmodal.module.css';

type DownloadReportModalPops = ModalProps & {
  client: string,
  survey?: any,
  filters?: any,
}

const DownloadReportModal = ({ survey, client, filters: propsFilters, ...modalProps }: DownloadReportModalPops) => {
  const thisYear = new Date().getFullYear();
  
  const [ loading, setLoading ] = useState(false);
  const [ fileLoading, setFileLoading ] = useState(false);
  const [ tags, setTags ] = useState<any[]>([]);
  const [ fromYear, setFromYear ] = useState<number>(thisYear);
  const [ filters, setFilters ] = useState(propsFilters);

  const [form] = Form.useForm();
  const yearValue = Form.useWatch('year', form);

  useEffect(() => {
    setFilters(propsFilters);
  }, [propsFilters]);

  useEffect(() => {
    const func = async () => {
      try {
        setLoading(true);
        const tags = await SurveysService.getSurveyTags(client, survey.id);
        const fromYear = await SurveysService.getFirstYear(client, survey.id);
        if(fromYear) setFromYear(fromYear);
        setTags(tags);
      }
      catch(err) {
        console.error(err);
        message.error((err as Error).message);
      }
      setLoading(false);
    };
    if(survey && survey.id) func();
  }, [survey, client]);

  const onFiltersChange = (changed: FieldData[], all: FieldData[]) => {
    const filters = all.reduce((prev: any, curr:FieldData) => {
      if(curr.value && curr.name.toString() !== 'year') {
        const val = moment.isMoment(curr.value) ? curr.value.format('YYYY-MM-DD') : curr.value;
        prev[curr.name.toString()] = val;
      }
      
      return prev;
    }, {});
    
    setFilters(filters);
  }

  const downloadReport = async () => {
    if(!survey) return;

    try {
      setFileLoading(true);
      let anchor = document.createElement("a");
      document.body.appendChild(anchor);
      
      const blob = await SurveysService.exportReport(client, survey.id, yearValue, yearValue === thisYear ? filters : {});

      let objectUrl = window.URL.createObjectURL(blob);
  
      anchor.href = objectUrl;
      anchor.download = `${client} - ${survey.title} - ${yearValue}.csv`;
      anchor.click();
  
      window.URL.revokeObjectURL(objectUrl);
    }
    catch(err) {
      if(err instanceof ApiError && err.data.statusCode === 404) {
        message.warning(err.data.message);
      }
      else {
        message.error('Ocurrió un error al descargar el reporte');
        console.error(err);
      }
    }

    setFileLoading(false);
  }

  return <Modal confirmLoading={fileLoading} destroyOnClose title="Exportar reporte" okText="Descargar" cancelText="Cerrar" {...modalProps} onOk={downloadReport}>
   
    <Form id="frmRptFlt" className={styles.downloadForm} form={form} layout="vertical" onFieldsChange={onFiltersChange}>
      <Row gutter={16}>
        <Col span={8}>
        <Form.Item name="year" label="Año" initialValue={thisYear}>
          <Select>
            { new Array(thisYear - fromYear + 1).fill(0).map((_, i) => thisYear - i)
              .map((year) => 
                <Select.Option key={year} value={year}>{ year === thisYear ? `Actual (${year})` : year }</Select.Option>
              )
            }
          </Select>
        </Form.Item>
        </Col>
        <Col span={16}>
         <p>Si el reporte que vas a generar es del año actual puedes definir filtros para la información, para años anteriores se descarga toda la información pero la puedes filtrar en Excel o una aplicación de hojas de cálculo.</p>
        </Col>
      </Row>
      { yearValue === thisYear && <Row gutter={16}>
        <Col span={24} style={{marginBottom: 16}}><strong>Filtros</strong></Col>
        { loading && <Col span={24}><Spin spinning>Cargando...</Spin></Col> }
        { !loading && <Col span={12}>
          <Form.Item name="from" label="Fecha inicial" initialValue={filters?.from && moment(filters.from).year() === yearValue ? moment(filters.from) : undefined}>
            <DatePicker format="DD/MM/YYYY" disabledDate={(curr) => curr.year() !== yearValue} />
          </Form.Item>
        </Col> }
        { !loading && <Col span={12}>
          <Form.Item name="to" label="Fecha final" initialValue={filters?.to && moment(filters.to).year() === yearValue ? moment(filters.to) : undefined}>
            <DatePicker format="DD/MM/YYYY" disabledDate={(curr) => curr.year() !== yearValue} />
          </Form.Item>
        </Col> }
        { !loading && tags.map(tag => <Col key={tag.id} span={12}>
          <Form.Item name={tag.name} label={tag.name} initialValue={filters?.hasOwnProperty(tag.name) ? filters[tag.name]||undefined : undefined}>
            <Select mode="multiple" placeholder="Todos">
              { tag.values.map((value: any) => <Select.Option key={value} value={value}>{value}</Select.Option>) }
            </Select>
          </Form.Item>
        </Col> )}

        { !loading && <Col span={12}>
        <Form.Item label="¿Sólo códigos activos?" valuePropName="checked" name="only_active" initialValue={filters?.only_active??false}>
          <Switch />
        </Form.Item>
      </Col> }
      </Row>
    }
      
      
    </Form>
  </Modal>
};


export default DownloadReportModal;